import type { RedFlag } from "../../../types/gpSummary";
import Card from "./Card";

interface RedFlagHistoryCardProps {
  redFlags: RedFlag[];
}

export default function RedFlagHistoryCard({ redFlags }: RedFlagHistoryCardProps) {
  return (
    <Card title="Red-Flag History">
      <div className="flex flex-col gap-3">
        {redFlags.length > 0 ? (
          redFlags.map((f, i) => (
            <div key={`${f.week}-${i}`} className="flex items-start gap-3 p-3.5 rounded-xl bg-[#F5E8E8]">
              <span className="w-2 h-2 rounded-full flex-shrink-0 mt-1.5 bg-[#C97C7C]" />
              <p className="text-sm text-stone-700">
                <span className="font-semibold text-[#C97C7C]">{f.week} · </span>
                {f.label}
              </p>
            </div>
          ))
        ) : (
          <div className="flex gap-2 p-3 rounded-xl bg-[#f0f6e4] items-start">
            <span className="text-sm flex-shrink-0">{"\u2705"}</span>
            <p className="text-xs leading-relaxed text-[#6C7A52]">
              No red-flag alerts were triggered during the programme.
            </p>
          </div>
        )}
        <p className="text-xs leading-relaxed p-3 rounded-lg bg-[#FBF3E0] text-[#6B5A2B]">
          {"\u2139\uFE0F"} Only alert triggers are recorded — no clinical conclusions are stored.
        </p>
      </div>
    </Card>
  );
}
